export default `<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="500.000000pt" height="500.000000pt" viewBox="0 0 500.000000 500.000000"
 preserveAspectRatio="xMidYMid meet">

<g transform="translate(0.000000,500.000000) scale(0.100000,-0.100000)"
fill="#9D1F19" stroke="none">
<path d="M2345 4280 c-288 -24 -601 -132 -837 -287 -305 -201 -550 -500 -685
-836 -56 -138 -119 -377 -100 -377 2 0 30 9 61 20 81 27 216 44 299 35 191
-18 340 -86 493 -225 103 -93 213 -131 322 -110 85 16 117 35 298 175 255 199
364 250 556 262 168 10 334 -31 464 -116 56 -36 549 -457 568 -486 7 -9 -27
-54 -123 -164 -73 -83 -136 -151 -139 -151 -4 0 -97 79 -207 176 -359 315
-374 324 -510 324 -114 0 -155 -21 -360 -180 -283 -220 -367 -255 -605 -255
-111 1 -159 5 -205 19 -135 42 -229 96 -342 198 -97 88 -156 113 -268 113 -77
0 -98 -4 -148 -27 -66 -31 -167 -122 -167 -150 0 -11 9 -65 21 -120 47 -229
166 -497 299 -678 39 -52 74 -96 79 -98 4 -1 79 63 164 144 185 173 220 200
314 247 107 55 206 77 337 77 214 0 374 -64 532 -211 91 -85 157 -113 259
-114 70 0 88 4 145 32 36 18 103 64 150 104 236 197 543 242 816 119 68 -31
169 -96 198 -129 11 -11 22 -21 26 -21 14 0 129 257 159 355 54 173 73 293 78
490 4 137 1 207 -11 295 -38 262 -127 508 -259 714 l-50 78 -41 -6 c-67 -11
-136 -49 -225 -124 -178 -152 -372 -214 -591 -191 -178 18 -311 83 -481 234
-91 81 -199 109 -309 81 -35 -9 -79 -26 -97 -37 -19 -12 -134 -115 -256 -230
l-222 -209 -133 138 c-72 75 -136 144 -142 153 -7 13 31 53 192 205 249 234
309 283 400 328 120 59 219 79 367 74 108 -4 139 -9 214 -35 111 -39 181 -81
274 -165 105 -95 165 -122 273 -123 104 0 164 25 255 105 51 45 119 93 190
136 16 9 6 19 -71 75 -284 207 -586 320 -934 349 -127 11 -153 11 -285 0z"/>
<path d="M1839 1386 c-25 -7 -64 -23 -86 -37 -38 -22 -324 -282 -331 -300 -5
-12 148 -109 254 -163 124 -62 229 -102 363 -139 l116 -31 302 -4 c343 -4 386
1 596 68 237 76 483 221 655 385 l87 83 -40 42 c-58 59 -131 92 -219 98 -101
6 -169 -15 -248 -78 -197 -157 -245 -185 -383 -220 -99 -26 -249 -28 -354 -6
-104 22 -242 92 -326 165 -161 140 -253 173 -386 137z"/>
</g>
</svg>
`;
